import React from "react";
import FullscreenVideo from "../components/FullscreenVideo"; // Ensure FullscreenVideo is imported

const RaagAsa = () => {

    return (
        <div className="fullscreen-video-container">
            <h2>Raag Asa</h2>
            <FullscreenVideo />
        </div>
    );
};

export default RaagAsa;
